module.exports = new __parcel__URL__("quickSummaryUpsellBannerLight.edcc3647.svg").toString();